module.exports = __webpack_public_path__ + "img/__rocket02_allwhite.5443f24b.svg";